module.exports={analyticsCode:"UA-76350303-7",footer:{notice:"New Amma Srl.",year:2020}};